import { ChangeEvent, useCallback, useEffect } from "react";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import useUiuxStore from "src/store/useUiuxStore";
import { defaultPRD2040_R01Filter, usePRD2040_R01Store } from "./Store_PRD2040_R01";
import { ItemDto } from "src/dtos/item/itemDto";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { getItemPopupList } from "src/apis/itemApi";
import { getProductWorkPopupList } from "src/apis/productWorkApi";

interface Props {
    onEnterKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchSection_PRD2040_R01 = ({ onEnterKeyDown }: Props) => {
    const { PRD2040_R01Filter, setPRD2040_R01Filter } = usePRD2040_R01Store();
    const { setCodeSearchModalProps } = useUiuxStore();

	const compareItemCdHandleFoucsId = 'compareItemCd_search';
	const productWorkNoHandleFoucsId = 'productWorkNo_search';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'compareItemCd',
			category: '품목',
			focusId: compareItemCdHandleFoucsId,
			responseMapping: {
				itemCd: 'compareItemCd',
				itemNm: 'compareItemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(searchText, '', '', '');
				return itemResponse.data.data.find(value => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: PRD2040_R01Filter.compareItemCd || '',
				itemNm: PRD2040_R01Filter.compareItemNm || '',
			}),
		},
		{
			fieldName: 'productWorkNo',
			category: '공정작업',
			focusId: productWorkNoHandleFoucsId,
			responseMapping: {
				productWorkNo: 'productWorkNo',
				itemNm: 'productWorkItemNm',
			},
			searchFunction: async (searchText: string) => {
				const productWorkResponse = await getProductWorkPopupList(searchText, '', 'N');
				return productWorkResponse.data.data.find(value => value.productWorkNo === searchText);
			},
			extraFilter: () => ({
				productWorkNo: PRD2040_R01Filter.productWorkNo || '',
				itemNm: PRD2040_R01Filter.productWorkItemNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: PRD2040_R01Filter,
		setEditData: setPRD2040_R01Filter,
		defaultData: defaultPRD2040_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD2040_R01_search'
	});

    return (
        <div className="w-full">
            <SearchSectionDoubleForm>
                <SearchCodeModalForm
                    label="공정지시 품목"
                    value={PRD2040_R01Filter.productWorkNo}
                    valueLabel={PRD2040_R01Filter.productWorkItemNm || ''}
					handleFoucsId={productWorkNoHandleFoucsId}
                    onChange={getFieldHandlers('productWorkNo').onChange}
                    onDoubleClick={getFieldHandlers('productWorkNo').onDoubleClick}
                    onKeyDown={getFieldHandlers('productWorkNo').onEnterKeyDown}
                    wrapperOption={{
                        wrapperStyle: "w-[400px] min-w-[400px] mr-[10px]",
                        titleStyle: "!w-[70px] !min-w-[70px] text-left ",
                        codeInputStyle: "w-[100px] min-w-[100px]",
                        nameTagStyle: "w-[190px] min-w-[190px] text-left",
                    }}
                />

                <SearchCodeModalForm
                    label="비교 품목"
                    value={PRD2040_R01Filter.compareItemCd}
                    valueLabel={PRD2040_R01Filter.compareItemNm || ''}
					handleFoucsId={compareItemCdHandleFoucsId}
                    onChange={getFieldHandlers('compareItemCd').onChange}
                    onDoubleClick={getFieldHandlers('compareItemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('compareItemCd').onEnterKeyDown}
                    wrapperOption={{
                        wrapperStyle: "w-[400px] min-w-[400px] mr-[10px]",
                        titleStyle: "!w-[50px] !min-w-[50px] text-left",
                        codeInputStyle: "w-[100px] min-w-[100px]",
                        nameTagStyle: "w-[190px] min-w-[190px] text-left",
                    }}
                />

                <SearchDropDownForm
                    label="출력"
                    value={PRD2040_R01Filter.outputType}
                    optionList={[
                        { majorCd: '', minorCd: 'BOM', codeNm: 'BOM 검토', dispSeq: 1 } as any,
                        { majorCd: '', minorCd: 'COORD', codeNm: '좌표검토', dispSeq: 2 } as any,
                    ]}
                    onChangeValue={(v) => setPRD2040_R01Filter({ outputType: v as 'BOM' | 'COORD' })}
                />
            </SearchSectionDoubleForm>
        </div>
    );
};
